import React from 'react';
import Icon from '../../../components/AppIcon';

const RealtimeNotifications = ({ notifications, onDismiss }) => {
  if (!notifications || notifications?.length === 0) return null;

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'assignment': return 'Briefcase';
      case 'session': return 'Calendar';
      case 'performance': return 'TrendingUp';
      default: return 'Bell';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'assignment': return 'bg-primary/10 border-primary text-primary';
      case 'session': return 'bg-accent/10 border-accent text-accent';
      case 'performance': return 'bg-success/10 border-success text-success';
      default: return 'bg-muted/10 border-border text-foreground';
    }
  };

  return (
    <div className="fixed top-20 right-4 z-50 space-y-2 max-w-sm">
      {notifications?.map((notification) => (
        <div
          key={notification?.id}
          className={`flex items-start gap-3 p-4 rounded-lg border shadow-lg backdrop-blur-sm animate-slide-in-right ${
            getNotificationColor(notification?.type)
          }`}
        >
          <div className="flex-shrink-0 mt-0.5">
            <Icon name={getNotificationIcon(notification?.type)} size={20} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium">{notification?.message}</p>
            <p className="text-xs opacity-75 mt-1">
              {new Date(notification.timestamp)?.toLocaleTimeString()}
            </p>
          </div>
          <button
            onClick={() => onDismiss?.(notification?.id)}
            className="flex-shrink-0 hover:opacity-70 transition-opacity"
          >
            <Icon name="X" size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default RealtimeNotifications;